import { render, staticRenderFns } from "./pageTop.vue?vue&type=template&id=bf8fd7ec&scoped=true&"
import script from "./pageTop.vue?vue&type=script&lang=js&"
export * from "./pageTop.vue?vue&type=script&lang=js&"
import style0 from "./pageTop.vue?vue&type=style&index=0&id=bf8fd7ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8fd7ec",
  null
  
)

export default component.exports